module.exports = __webpack_public_path__ + "static/img/PRODUCT CARD_TPU HOT MELT FILM_mobile.d754dfd7.jpg";